import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { FieldPathByValue } from 'react-hook-form';

import { Termostatstyring } from '../../../../../../../components/registering/utils/registerEnums';
import { OppvarmingFormData } from '../../../types';
import { useOppvarmingFormContext } from '../../utils';

type TermostatstyringPath = FieldPathByValue<OppvarmingFormData, Termostatstyring>;

interface Props {
  name: TermostatstyringPath;
  labelHidden?: boolean;
  description?: string;
}

export const TermostatstyringRadio: FC<Props> = ({ labelHidden, name, description }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.common.termostatstyring' });
  const { register, getFieldState } = useOppvarmingFormContext();
  const { error } = getFieldState(name);

  return (
    <Fieldset>
      {!labelHidden && <Fieldset.Legend>{t('label')}</Fieldset.Legend>}
      {description && <Fieldset.Description>{description}</Fieldset.Description>}
      <Radio
        {...register(name, {
          shouldUnregister: true,
          required: t('error')
        })}
        label={t(`options.${Termostatstyring.TermostatstyrtUtenTidsstyring}`)}
        value={Termostatstyring.TermostatstyrtUtenTidsstyring}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, {
          shouldUnregister: true,
          required: t('error')
        })}
        label={t(`options.${Termostatstyring.TermostatstyrtMedTidsstyring}`)}
        value={Termostatstyring.TermostatstyrtMedTidsstyring}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, {
          shouldUnregister: true,
          required: t('error')
        })}
        label={t(`options.${Termostatstyring.UtenTermostat}`)}
        value={Termostatstyring.UtenTermostat}
        aria-invalid={!!error}
      />

      <Radio
        {...register(name, {
          shouldUnregister: true,
          required: t('error')
        })}
        label={t(`options.${Termostatstyring.Ukjent}`)}
        value={Termostatstyring.Ukjent}
        aria-invalid={!!error}
      />
      {error?.message && <ValidationMessage data-color="danger">{error.message}</ValidationMessage>}
    </Fieldset>
  );
};
